import React from 'react';

export type ListEntry = { text: string; image?: string };

export type ListCelProps = {
  items?: string[];
  entries?: ListEntry[];
  orientation?: 'vertical'|'horizontal';
  borderRadius?: number;
  className?: string;
  imageSize?: number; // px
  imageRadius?: number; // px
};

const ListCel: React.FC<ListCelProps> = ({ items = [], entries, orientation = 'vertical', borderRadius = 8, className, imageSize = 24, imageRadius = 6 }) => {
  const isH = orientation === 'horizontal';
  const data: ListEntry[] = (entries && entries.length)
    ? entries
    : (items || []).map(t => ({ text: t }));
  return (
    <div className={`h-full w-full overflow-hidden ${className||''}`} style={{ borderRadius }}>
      <div className={isH ? 'flex gap-3 items-start p-3 flex-wrap' : 'flex flex-col gap-2 p-3'}>
        {data.length > 0 && data.map((it, idx) => (
          <div key={idx} className={`flex items-center gap-2 ${isH ? 'px-2 py-1 rounded-lg bg-white/70 border border-gray-200' : ''}`}>
            <div className="mt-1 h-2 w-2 rounded-full bg-gray-400 shrink-0" />
            {it.image && (
              <img src={it.image} alt="" style={{ height: imageSize, width: imageSize, borderRadius: imageRadius }} className="object-cover border border-gray-200" />
            )}
            <div className="text-gray-800 text-sm leading-snug">{it.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListCel;
